import request from '@/utils/request';
import { datasetCollectionsEndpoint } from '@/constants/urls';

const collections = (code, filter = null, assignableFlag = false) => {
  const params = {};
  if (filter) {
    params.filter = filter;
  }
  if (assignableFlag) {
    params.assignable = true;
    params.page = 1;
    params.pageSize = 20;
  }

  return (
    request({
      url: datasetCollectionsEndpoint(code),
      params,
      method: 'GET',
    })
  );
};

const DatasetCollectionsService = {
  collections,
};

export default DatasetCollectionsService;
